// Constants
const DESKTOP_BREAKPOINT = '(max-width: 767px)';
const DROPDOWN_CLOSE_DELAY = 220;
const ARROW_SVG = '<svg width="12" height="6" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function enhanceWpmlMenu(ul) {
  if (!ul || ul.dataset.wpmlDropdownEnhanced === 'true') return;

  const langItems = Array.from(ul.children).filter((li) => {
    return li.classList && Array.from(li.classList).some((className) => className.indexOf('wpml-ls-item') === 0);
  });

  // Reorder so current language (wpml-ls-current-language) is always first
  const currentLangItem = langItems.find((li) => li.classList.contains('wpml-ls-current-language'));
  if (currentLangItem && langItems[0] !== currentLangItem) {
    langItems = [currentLangItem].concat(langItems.filter((li) => li !== currentLangItem));
  }

  if (langItems.length < 2) return;

  const trigger = langItems[0];
  const rest = langItems.slice(1);

  trigger.classList.add('wpml-ls-has-dropdown');

  // Add down arrow to the language trigger link (desktop only)
  const link = trigger.querySelector('a');
  if (link && !link.querySelector('.wpml-arrow')) {
    const arrow = document.createElement('span');
    arrow.className = 'wpml-arrow';
    arrow.innerHTML = ARROW_SVG;
    link.appendChild(arrow);
  }

  const submenu = document.createElement('ul');
  submenu.className = 'wpml-ls-dropdown-menu';
  rest.forEach((li) => submenu.appendChild(li));
  trigger.appendChild(submenu);

  let open = false;

  function setOpen(state) {
    open = state;
    if (state) {
      trigger.classList.add('is-open');
      if (link) link.setAttribute('aria-expanded', 'true');
    } else {
      trigger.classList.remove('is-open');
      if (link) link.setAttribute('aria-expanded', 'false');
    }
  }

  let closeTimer = null;
  function clearCloseTimer() { 
    if (closeTimer) { 
      clearTimeout(closeTimer); 
      closeTimer = null; 
    } 
  }
  
  function scheduleClose() {
    clearCloseTimer();
    closeTimer = setTimeout(() => {
      // Prevent closing if focus moved inside
      if (trigger.contains(document.activeElement)) return;
      setOpen(false);
    }, DROPDOWN_CLOSE_DELAY);
  }

  if (link) {
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('mouseenter', () => { 
      if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) { 
        clearCloseTimer(); 
        setOpen(true); 
      } 
    });
    
    trigger.addEventListener('mouseleave', () => { 
      if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) scheduleClose(); 
    });

    // Keep submenu open while hovering it
    const submenuEl = trigger.querySelector('.wpml-ls-dropdown-menu');
    if (submenuEl) {
      submenuEl.addEventListener('mouseenter', () => clearCloseTimer());
      submenuEl.addEventListener('mouseleave', () => scheduleClose());
    }

    // Keyboard accessibility: open on focus within, close after focus leaves
    trigger.addEventListener('focusin', () => { 
      if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) { 
        clearCloseTimer(); 
        setOpen(true); 
      } 
    });
    
    trigger.addEventListener('focusout', () => { 
      if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) scheduleClose(); 
    });

    link.addEventListener('click', (e) => {
      if (window.matchMedia(DESKTOP_BREAKPOINT).matches) return; // disable dropdown behavior on mobile
      if (!open) {
        e.preventDefault();
        setOpen(true);
      }
    });

    document.addEventListener('click', (e) => {
      if (window.matchMedia(DESKTOP_BREAKPOINT).matches) return; // ignore on mobile
      if (!trigger.contains(e.target)) setOpen(false);
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  ul.dataset.wpmlDropdownEnhanced = 'true';
}

function moveWpmlToRight() {
  const mainNav = document.querySelector('ul.main-navigation');
  if (!mainNav) return;

  // Find all WPML language items in main navigation
  const wpmlItems = Array.from(mainNav.children).filter((li) => {
    return li.classList && Array.from(li.classList).some((className) => className.indexOf('wpml-ls-item') === 0);
  });

  if (wpmlItems.length === 0) return;

  // Find or create the languages container in header__right
  const headerRight = document.querySelector('.header__right');
  if (!headerRight) return;

  let langContainer = headerRight.querySelector('.header__languages-desktop');
  if (!langContainer) {
    langContainer = document.createElement('div');
    langContainer.className = 'header__languages-desktop';
    
    // Insert before the connect button
    const connectBtn = headerRight.querySelector('.header__connect');
    if (connectBtn) {
      headerRight.insertBefore(langContainer, connectBtn);
    } else {
      headerRight.appendChild(langContainer);
    }
  }

  // Create or get the language list
  let langList = langContainer.querySelector('ul.language-switcher-desktop');
  if (!langList) {
    langList = document.createElement('ul');
    langList.className = 'language-switcher-desktop';
    langContainer.appendChild(langList);
  }

  // Move WPML items to the new location and simplify their structure
  wpmlItems.forEach((item) => {
    // Simplify the link structure for desktop languages (remove animation markup)
    const link = item.querySelector('a');
    if (link) {
      const nativeSpan = link.querySelector('.wpml-ls-native');
      if (nativeSpan) {
        const langCode = nativeSpan.textContent.trim();
        const title = link.getAttribute('title');
        const href = link.getAttribute('href');
        
        // Clear the link content and rebuild it simply
        link.innerHTML = langCode;
        
        // Restore attributes
        if (title) link.setAttribute('title', title);
        if (href) link.setAttribute('href', href);
      }
    }
    langList.appendChild(item);
  });

  // Manually enhance the desktop language switcher
  let langItems = Array.from(langList.children).filter((li) => {
    return li.classList && Array.from(li.classList).some((className) => className.indexOf('wpml-ls-item') === 0);
  });

  // Reorder so current language is first
  const currentLangItem = langItems.find((li) => li.classList.contains('wpml-ls-current-language'));
  if (currentLangItem && langItems[0] !== currentLangItem) {
    langItems = [currentLangItem].concat(langItems.filter((li) => li !== currentLangItem));
    // Re-append in correct order
    langItems.forEach((li) => langList.appendChild(li));
  }

  if (langItems.length >= 2) {
    const trigger = langItems[0];
    const rest = langItems.slice(1);
    
    trigger.classList.add('wpml-ls-has-dropdown');
    
    // Add arrow to trigger link
    const link = trigger.querySelector('a');
    if (link && !link.querySelector('.wpml-arrow')) {
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      
      const arrow = document.createElement('span');
      arrow.className = 'wpml-arrow';
      arrow.innerHTML = ARROW_SVG;
      link.appendChild(arrow);
    }
    
    // Create submenu if it doesn't exist
    const existingSubmenu = trigger.querySelector('.wpml-ls-dropdown-menu');
    if (!existingSubmenu) {
      const submenu = document.createElement('ul');
      submenu.className = 'wpml-ls-dropdown-menu';
      rest.forEach((li) => submenu.appendChild(li));
      trigger.appendChild(submenu);
    }
    
    // Add dropdown behavior
    let open = false;
    
    function setOpen(state) {
      open = state;
      if (state) {
        trigger.classList.add('is-open');
        if (link) link.setAttribute('aria-expanded', 'true');
      } else {
        trigger.classList.remove('is-open');
        if (link) link.setAttribute('aria-expanded', 'false');
      }
    }
    
    let closeTimer = null;
    function clearCloseTimer() { 
      if (closeTimer) { 
        clearTimeout(closeTimer); 
        closeTimer = null; 
      } 
    }
    
    function scheduleClose() {
      clearCloseTimer();
      closeTimer = setTimeout(() => {
        if (trigger.contains(document.activeElement)) return;
        setOpen(false);
      }, DROPDOWN_CLOSE_DELAY);
    }
    
    if (link) {
      trigger.addEventListener('mouseenter', () => { 
        if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) { 
          clearCloseTimer(); 
          setOpen(true); 
        } 
      });
      
      trigger.addEventListener('mouseleave', () => { 
        if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) scheduleClose(); 
      });
      
      const submenuEl = trigger.querySelector('.wpml-ls-dropdown-menu');
      if (submenuEl) {
        submenuEl.addEventListener('mouseenter', () => clearCloseTimer());
        submenuEl.addEventListener('mouseleave', () => scheduleClose());
      }
      
      trigger.addEventListener('focusin', () => { 
        if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) { 
          clearCloseTimer(); 
          setOpen(true); 
        } 
      });
      
      trigger.addEventListener('focusout', () => { 
        if (!window.matchMedia(DESKTOP_BREAKPOINT).matches) scheduleClose(); 
      });
      
      link.addEventListener('click', (e) => {
        if (window.matchMedia(DESKTOP_BREAKPOINT).matches) return;
        if (!open) {
          e.preventDefault();
          setOpen(true);
        }
      });
      
      document.addEventListener('click', (e) => {
        if (window.matchMedia(DESKTOP_BREAKPOINT).matches) return;
        if (!trigger.contains(e.target)) setOpen(false);
      });
      
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') setOpen(false);
      });
    }
  }
  
  langList.dataset.wpmlDropdownEnhanced = 'true';
}

export default function initWpmlMenuDropdown() {
  // Move WPML items to header right section FIRST, before enhancing
  moveWpmlToRight();

  const selectors = ['ul.main-navigation', 'ul.language-switcher-desktop'];
  let lists = [];
  selectors.forEach((sel) => {
    lists = lists.concat(Array.from(document.querySelectorAll(sel)));
  });

  lists.forEach(enhanceWpmlMenu);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.type === 'childList') {
        Array.from(m.addedNodes).forEach((node) => {
          if (node && node.nodeType === 1 && (node.matches && (node.matches('ul.main-navigation') || node.matches('ul.language-switcher-desktop')))) {
            enhanceWpmlMenu(node);
            // Try to move WPML items again when navigation changes
            setTimeout(moveWpmlToRight, 100);
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
